/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   falseReducer that always returns false
 */

import { alwaysReducer } from './alwaysReducer'

export const falseReducer = alwaysReducer<false>(false)
